import { httpClient } from "../http/httpClient";

export interface AuthorizationRequest {
  cpf: string;
  name: string;
  email: string;
  phone: string;
  birthDate: string;
}

export interface AuthorizationResponse {
  RegistrationNumber: string;
  EmployerDocumentNumber: number;
  Elegivel: boolean;
  ValorMargem: number;
}
export const requestAuthorization = async (payload: AuthorizationRequest) => {
  const { data } = await httpClient.post<AuthorizationResponse[]>(
    '/clt/authorization',
    payload,
  );
  return data;
};
